if (!customElements.get('fragrance-finder')) {
  customElements.define(
    'fragrance-finder',
    class FragranceFInder extends HTMLElement {
      constructor() {
        super();

        this.list = this.querySelector('#fragrance-finder-list');

        // Initialize Choices.js on the input element
        this.choices = new Choices(this.list, {
          allowHTML: true,
          shouldSort: false,
          position: 'top',
          placeholderValue: 'Search for a fragrance...',
          searchPlaceholderValue: 'Search for a fragrance...',
        });

        this.addEventListener(
          'addItem',
          function (event) {
            window.location.href = event.detail.customProperties['url'];
          },
          false
        );
      }
    }
  );
}
